<template>
  <div class="flex items-center gap-2">
    <p>Hora</p>
    <div
      class="bg-ontick-steel-500 custom-shadow flex h-[24px] items-center gap-0.5 rounded"
    >
      <input
        type="number"
        :step="1"
        :min="0"
        :max="23"
        placeholder="00"
        :value="value.hour"
        @blur="
          $emit('input', {
            ...value,
            hour: normalize($event.target.value, 'hour'),
          })
        "
      />
      <span>:</span>
      <input
        type="number"
        :step="1"
        :min="0"
        :max="59"
        placeholder="00"
        :value="value.minute"
        @blur="
          $emit('input', {
            ...value,
            minute: normalize($event.target.value, 'minute'),
          })
        "
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
    },
  },

  methods: {
    normalize(value, type) {
      if (type === "hour") {
        if (value > 23) {
          return 23;
        } else if (value < 0) {
          return 0;
        }
        return value;
      } else if (type === "minute") {
        if (value > 59) {
          return 59;
        } else if (value < 0) {
          return 0;
        }
        return value;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.custom-shadow {
  box-shadow: 0px 2px 4px 1px #00000059;
}
input {
  @apply h-full w-8 border-0 bg-transparent px-0.5 text-center text-sm;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
